class LineItemQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.hasPendingQuantityChange = false;
    this.isRemoving = false;
    this.quantityChangeTimeout = null;
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onLineItemWillChange = this.onLineItemWillChange.bind(this);
    this.submitQuantityChange = this.submitQuantityChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onButtonClick);
    this.closest("line-item")?.addEventListener("line-item:will-change", this.onLineItemWillChange);
  }

  disconnectedCallback() {
    clearTimeout(this.quantityChangeTimeout);

    if (this.hasPendingQuantityChange) {
      this.dispatchQuantityChange();
    }

    this.removeEventListener("click", this.onButtonClick);
    this.closest("line-item")?.removeEventListener("line-item:will-change", this.onLineItemWillChange);
  }

  onLineItemWillChange(event) {
    this.hasPendingQuantityChange = false;
    this.isRemoving = event.detail.targetQuantity === 0;
    clearTimeout(this.quantityChangeTimeout);
  }

  onButtonClick(event) {
    const button = event.target.closest("[data-quantity-change]");

    if (!button || button.disabled || this.isRemoving) {
      return;
    }

    const input = this.querySelector("[data-line-key]");
    const currentQuantity = parseInt(input.value);
    const adjustment = parseInt(button.getAttribute("data-quantity-change"));
    const maxQuantity = input.max ? parseInt(input.max) : Number.MAX_VALUE;
    const targetQuantity = Math.max(0, Math.min(currentQuantity + adjustment, maxQuantity));

    if (targetQuantity === currentQuantity) {
      return;
    }

    input.value = targetQuantity;
    this.hasPendingQuantityChange = true;
    clearTimeout(this.quantityChangeTimeout);
    this.quantityChangeTimeout = setTimeout(this.submitQuantityChange, 200);
  }

  submitQuantityChange() {
    const lineItem = this.closest("line-item");

    if (lineItem?.querySelector("pill-loader")?.hasAttribute("aria-busy")) {
      this.quantityChangeTimeout = setTimeout(this.submitQuantityChange, 100);
      return;
    }

    this.dispatchQuantityChange();
  }

  dispatchQuantityChange() {
    this.hasPendingQuantityChange = false;
    this.querySelector("[data-line-key]").dispatchEvent(new Event("change", { bubbles: true }));
  }
}

if (!window.customElements.get("line-item-quantity-selector")) {
  window.customElements.define("line-item-quantity-selector", LineItemQuantitySelector);
}
